




































































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';

import {
  TipoNotaProntuario,
  NotaProntuarioCriarFormData,
  NotaProntuarioAlterarFormData,
} from '../../../../back/src/types';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { Usuario } from '../../../../back/src/entity/Usuario';
import {
  gruposIdsUsuariosInternos,
  tiposNotasProntuarioItems,
  tipoNotaProntuarioIcons,
} from '../../utils/constants';
import { NotaProntuario } from '../../../../back/src/entity/NotaProntuario';

export default Vue.extend({
  name: 'NotasProntuarioForm',
  props: {
    paciente: {
      default: {} as Paciente,
    },
    notaProntuario: {
      type: Object as () => NotaProntuario | null,
      default: null,
    },
  },
  data() {
    return {
      tiposNotasProntuarioItems,
      valid: false,
      menuData: false,
      loading: false,
      usuarios: [] as Usuario[],
      form: {
        tipoNota: null,
        nota: null,
        responsavelId: null,
        data: '',
        hora: '',
      },
      rules: {
        required: [(v: string) => !!v || 'Campo obrigatório'],
        hora: [
          (v: string) => !!v || 'Campo obrigatório',
          (v: string) => {
            const timePattern: RegExp = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
            return (v && timePattern.test(v)) || 'Horário inválido';
          },
        ],
      },
    };
  },
  mounted() {
    this.buscaUsuarios();
    if (this.notaProntuario) {
      this.preencheForm();
    }
  },
  computed: {
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    vColClass(): string {
      return 'pt-1 pb-2';
    },
    formNotaProntuario(): Vue & {
      validate: () => boolean;
      resetValidation: () => void;
      } {
      return this.$refs.formNotaProntuario as Vue & {
        validate: () => boolean;
        resetValidation: () => void;
      };
    },
    dataFormatada(): string {
      if (this.form.data) {
        const momentData = moment(this.form.data);
        if (momentData.isValid()) {
          return momentData.format('DD/MM/YYYY');
        }
      }
      return '';
    },
    usuariosItens() {
      return _.orderBy(
        _.map(
          _.filter(
            this.usuarios,
            usuario => !usuario.email.includes('@kemiocode'),
          ),
          usuario => ({ value: usuario.id, text: usuario.nome }),
        ),
        ['text'],
      );
    },
  },
  methods: {
    tipoNotaIcon(tipoNota: TipoNotaProntuario) {
      return tipoNotaProntuarioIcons[tipoNota];
    },
    async buscaUsuarios() {
      this.loading = true;
      try {
        const response = await Requester.usuario.usuarios({
          grupo_id: gruposIdsUsuariosInternos,
          ativo: 'true',
        });
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', {
            color: 'error',
            text: response.errors,
          });
        } else {
          this.usuarios = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () {
      await this.submitForm();
    }, 200),
    async submitForm() {
      if (!this.formNotaProntuario.validate()) {
        return;
      }
      this.loading = true;
      try {
        let response;
        let msgSuccess = 'Nota de prontuário registrada com sucesso.';
        let event = 'nova-nota-prontuario';
        if (this.notaProntuario) {
          const formData: NotaProntuarioAlterarFormData = {
            id: this.notaProntuario.id,
            tipo_nota: this.form.tipoNota,
          };
          response = await Requester.notaProntuario.alteraNota(formData);
          msgSuccess = 'Nota de prontuário alterada com sucesso.';
          event = 'nota-prontuario-alterada';
        } else {
          const formData: NotaProntuarioCriarFormData = {
            paciente_id: this.paciente.id,
            gestacao_id: this.paciente.gestacao_atual
              ? this.paciente.gestacao_atual.id
              : null,
            tipo_nota: this.form.tipoNota,
            nota: this.form.nota,
            responsavel_id: this.form.responsavelId,
            data_nota: moment(`${this.form.data} ${this.form.hora}`).toDate(),
          };
          response = await Requester.notaProntuario.criaNota(formData);
        }
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', {
            color: 'error',
            text: response.errors,
          });
        } else {
          this.$root.$emit('avisoSnackbar', {
            color: 'success',
            text: msgSuccess,
          });
          this.$emit(event, response.data);
          this.limpaForm();
          this.formNotaProntuario.resetValidation();
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
    limpaForm() {
      // limpar form manualmente pra evitar atribuicao à computed property
      this.form.data = null;
      this.form.hora = null;
      this.form.nota = null;
      this.form.responsavelId = null;
      this.form.tipoNota = null;
    },
    preencheForm() {
      this.form.data = moment(this.notaProntuario.data_nota).format('YYYY-MM-DD');
      this.form.hora = moment(this.notaProntuario.data_nota).format('HH:mm');
      this.form.nota = this.notaProntuario.nota;
      this.form.responsavelId = this.notaProntuario.responsavel_id;
      this.form.tipoNota = this.notaProntuario.tipo_nota;
    },
  },
  watch: {
    paciente() {
      this.limpaForm();
      this.formNotaProntuario.resetValidation();
    },
  },
});
